// PageHeader — eyebrow + title + meta line + actions slot.
// Lives at the top of every module screen (e.g. "Accounts › Facilities" with
// search/filter/new buttons on the right). Mirrors the page header pattern
// in 20-account-management.html.
//
// The `meta` slot is for the "58 live · 3 onboarding · 4 red · 11 amber"
// summary line directly under the title. The `actions` slot is the right-
// aligned button cluster.

import type { ReactNode } from 'react';

export interface PageHeaderProps {
  /** Optional small uppercase eyebrow above the title (e.g. "Accounts"). */
  eyebrow?: ReactNode;
  title: ReactNode;
  /** Sub-line under the title for counts/status. */
  meta?: ReactNode;
  /** Right-aligned action buttons. */
  actions?: ReactNode;
  className?: string;
}

export function PageHeader({
  eyebrow,
  title,
  meta,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <header
      className={`flex flex-wrap items-end justify-between gap-3 border-b border-tcs-border pb-4 ${className ?? ''}`}
    >
      <div className="min-w-0">
        {eyebrow && (
          <div className="text-xs text-tcs-text-secondary">{eyebrow}</div>
        )}
        <h1 className="mt-0.5 text-2xl font-semibold tracking-tight text-tcs-text">
          {title}
        </h1>
        {meta && (
          <div className="mt-1 text-sm text-tcs-text-secondary">{meta}</div>
        )}
      </div>
      {actions && (
        <div className="flex shrink-0 items-center gap-2">{actions}</div>
      )}
    </header>
  );
}
